<template>
  <v-container class="body-container px-0 px-sm-3 px-xl-6" fluid>
    <h3 class="white--text text-center">
      {{ $t("questionnaire.title") }}
    </h3>
    <v-form v-model="form_validate_status" ref="form">
      <!-- ข้อมูลทั่วไป -->
      <v-card class="mt-3 mt-sm-3 mt-xl-6">
        <v-card-title>
          {{ $t("questionnaire.general_information") }}
        </v-card-title>
        <v-card-text class="px-1 px-md-3 px-xl-6">
          <v-row>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="provinceId"
                v-bind:label="$t('questionnaire.birthplace')"
                v-bind:item-text="
                  (item) => objectTranslator(item, 'PROVINCE_NAME')
                "
                v-bind:items="provinces"
                v-bind:item-value="(item) => item.PROVINCE_ID"
                v-bind:rules="requiredRules"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="device"
                v-bind:label="$t('questionnaire.device')"
                v-bind:item-text="(item) => objectTranslator(item, 'name')"
                v-bind:items="device_group"
                v-bind:item-value="(item) => item.device_value"
                v-bind:rules="requiredRules"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="5">
              <v-autocomplete
                v-model="newsSource"
                v-bind:label="$t('questionnaire.news_source')"
                v-bind:item-text="(item) => objectTranslator(item, 'name')"
                v-bind:items="newsSource_group"
                v-bind:item-value="(item) => item.newsSource_value"
                v-bind:rules="requiredRules"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="7" v-if="this.newsSource === 'Other'">
              <v-text-field
                v-model="newsSource_other"
                v-bind:label="$t('questionnaire.news_source_specify')"
                v-bind:placeholder="$t('questionnaire.news_source_specify')"
                v-bind:rules="requiredRules"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="5">
              <v-autocomplete
                v-model="internet"
                v-bind:label="$t('questionnaire.internet_used')"
                v-bind:item-text="(item) => objectTranslator(item, 'name')"
                v-bind:items="internet_group"
                v-bind:item-value="(item) => item.internet_value"
                v-bind:rules="requiredRules"
                outlined
                dense
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="7" v-if="this.internet === 'Other'">
              <v-text-field
                v-model="internet_other"
                v-bind:label="$t('questionnaire.internet_used_specify')"
                v-bind:placeholder="$t('questionnaire.internet_used_specify')"
                v-bind:rules="requiredRules"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- ระดับความพึงพอใจ -->
      <v-card class="mt-3 mt-sm-3 mt-xl-6">
        <v-card-title>
          {{ $t("questionnaire.level_satisfaction_user") }}
        </v-card-title>
        <v-card-text class="px-1 px-md-3 px-xl-6">
          <p class="pl-2">
            {{ $t("questionnaire.please_fill_in_truth") }}
          </p>
          <v-simple-table>
            <template v-slot:default>
              <thead class="blue-grey lighten-2">
                <tr>
                  <th class="text-center">
                    <h2>{{ $t("questionnaire.header_table1") }}</h2>
                  </th>
                  <th colspan="3" class="text-center">
                    <h2>{{ $t("questionnaire.header_table2") }}</h2>
                    {{ $t("questionnaire.header_table2_hint") }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <!-- ข้อ 1 -->
                <tr>
                  <td colspan="4" class="grey lighten-2">
                    <h4>{{ $t("questionnaire.Q1") }}</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q1_1") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q1_1" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q1_1">
                      ({{ Q1_1 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q1_1"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q1_2") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q1_2" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q1_2">
                      ({{ Q1_2 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q1_2"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q1_3") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q1_3" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q1_3">
                      ({{ Q1_3 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q1_3"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q1_4") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q1_4" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q1_4">
                      ({{ Q1_4 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q1_4"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q1_5") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q1_5" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q1_5">
                      ({{ Q1_5 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q1_5"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <!-- ข้อ 2 -->
                <tr>
                  <td colspan="4" class="grey lighten-2">
                    <h4>{{ $t("questionnaire.Q2") }}</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">
                      {{ $t("questionnaire.Q2_1") }}
                    </p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q2_1" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q2_1">
                      ({{ Q2_1 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q2_1"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q2_2") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q2_2" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q2_2">
                      ({{ Q2_2 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q2_2"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q2_3") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q2_3" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q2_3">
                      ({{ Q2_3 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q2_3"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q2_4") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q2_4" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q2_4">
                      ({{ Q2_4 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q2_4"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <!-- ข้อ 3 -->
                <tr>
                  <td colspan="4" class="grey lighten-2">
                    <h4>{{ $t("questionnaire.Q3") }}</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">
                      {{ $t("questionnaire.Q3_1") }}
                    </p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q3_1" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q3_1">
                      ({{ Q3_1 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q3_1"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q3_2") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q3_2" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q3_2">
                      ({{ Q3_2 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q3_2"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q3_3") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q3_3" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q3_3">
                      ({{ Q3_3 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q3_3"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="tab">{{ $t("questionnaire.Q3_4") }}</p>
                  </td>
                  <td class="text-center">
                    <RatingCard v-model="Q3_4" v-bind:rules="requiredRules" />
                  </td>
                  <td class="text-left">
                    <span class="red--text text--lighten-2" v-if="Q3_4">
                      ({{ Q3_4 }})
                    </span>
                  </td>
                  <td class="text-center">
                    <v-input
                      :value="Q3_4"
                      v-bind:rules="intGratterZeroRules"
                    ></v-input>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <!-- ข้อมูลเพิ่มเติม -->
      <v-card class="mt-3 mt-sm-3 mt-xl-6">
        <v-card-title>
          {{ $t("questionnaire.additional_info") }}
        </v-card-title>
        <v-card-text class="px-1 px-md-3 px-xl-6">
          <v-row>
            <v-col cols="12" md="12">
              <h5>
                <span class="red--text" v-if="!hasEnoughStar">*</span>
              </h5>
              <v-text-field
                v-if="hasEnoughStar"
                v-model="additional_1"
                v-bind:label="$t('questionnaire.additional_1')"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                v-if="!hasEnoughStar"
                v-model="additional_1"
                v-bind:label="$t('questionnaire.additional_1')"
                outlined
                dense
                :rules="requiredRulesTextarea"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="additional_2"
                v-bind:label="$t('questionnaire.additional_2')"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                v-model="additional_3"
                v-bind:label="$t('questionnaire.additional_3')"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            elevation="0"
            color="success"
            :disabled="!form_validate_status"
            @click="validate()"
            >{{ $t("menu.save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { objectTranslator, inlineTranslator } from "@/helper/translator";
import RatingCard from "@/components/info_cards/Rating";
import validator from "@/helper/validator";
import QuestionnaireProvider from "@/services/questionnaire.provider";

const questionnaireService = new QuestionnaireProvider();

export default {
  name: "Questionnaire",
  data: function () {
    return {
      loading: false,
      form_validate_status: null,

      provinceId: null,
      device: null,
      newsSource: null,
      newsSource_other: null,
      internet: null,
      internet_other: null,

      Q1_1: null,
      Q1_2: null,
      Q1_3: null,
      Q1_4: null,
      Q1_5: null,

      Q2_1: null,
      Q2_2: null,
      Q2_3: null,
      Q2_4: null,

      Q3_1: null,
      Q3_2: null,
      Q3_3: null,
      Q3_4: null,

      additional_1: null,
      additional_2: null,
      additional_3: null,

      requiredRules: [validator.required],
      intGratterZeroRules: [validator.int_gratter_zero],
      requiredRulesTextarea: [validator.required, validator.minChar(50)],

      newsSource_group: [
        {
          newsSource_value: "www",
          name_TH: "เว็บไซต์ (WWW)",
          name_EN: "Website (WWW)",
        },
        {
          newsSource_value: "FB",
          name_TH: "Facebook (FB)",
          name_EN: "Facebook (FB)",
        },
        {
          newsSource_value: "IG",
          name_TH: "Instagram (IG)",
          name_EN: "Instagram (IG)",
        },
        {
          newsSource_value: "Line",
          name_TH: "Line",
          name_EN: "Line",
        },
        {
          newsSource_value: "PR",
          name_TH: "งานแนะแนว/ประชาสัมพันธ์จากสถานศึกษา",
          name_EN: "Guidance/ Public Relations",
        },
        {
          newsSource_value: "Other",
          name_TH: "สื่ออื่นๆ",
          name_EN: "Other",
        },
      ],

      device_group: [
        {
          device_value: "Android",
          name_TH: "โทรศัพท์มือถือ Android",
          name_EN: "Android System Mobile Phone",
        },
        {
          device_value: "iPhone",
          name_TH: "โทรศัพท์มือถือ iPhone",
          name_EN: "iPhone",
        },
        {
          device_value: "Notebook",
          name_TH: "Notebook (Windows)",
          name_EN: "Notebook (Windows)",
        },
        {
          device_value: "Macbook",
          name_TH: "Macbook (macOS)",
          name_EN: "Macbook (macOS)",
        },
        {
          device_value: "PC",
          name_TH: "คอมพิวเตอร์ตั้งโต๊ะ (PC)",
          name_EN: "Personal Computer (PC)",
        },
        {
          device_value: "iMac",
          name_TH: "iMac",
          name_EN: "iMac",
        },
      ],

      internet_group: [
        {
          internet_value: "Own",
          name_TH: "ใช้เน็ตส่วนตัว",
          name_EN: "Personal Internet",
        },
        {
          internet_value: "Home",
          name_TH: "ใช้เน็ตบ้าน",
          name_EN: "Home Internet",
        },
        {
          internet_value: "School",
          name_TH: "ใช้เน็ตโรงเรียน/หน่วยงาน",
          name_EN: "School Internet/Agency",
        },
        {
          internet_value: "Cafe",
          name_TH: "ใช้เน็ตบริการร้านอินเตอร์เน็ต/Cafe",
          name_EN: "internet Cafe Services",
        },
        {
          internet_value: "Public",
          name_TH: "ใช้เน็ตสาธารณะ",
          name_EN: "Public Internet",
        },
        {
          internet_value: "Other",
          name_TH: "อื่นๆ",
          name_EN: "Other",
        },
      ],
    };
  },
  components: { RatingCard },

  methods: {
    objectTranslator,
    inlineTranslator,

    async fetch_data() {
      const uid = localStorage.getItem("uid");
      const data = await questionnaireService.getQuestionnaire(uid);

      this.provinceId = data.PROVINCE_ID;
      this.device = data.DEVICE;
      this.newsSource = data.NEWS;
      this.newsSource_other = data.NEWS_OTHER;
      this.internet = data.INTERNET;
      this.internet_other = data.INTERNET_OTHER;

      this.Q1_1 = parseInt(data.Q1_1);
      this.Q1_2 = parseInt(data.Q1_2);
      this.Q1_3 = parseInt(data.Q1_3);
      this.Q1_4 = parseInt(data.Q1_4);
      this.Q1_5 = parseInt(data.Q1_5);

      this.Q2_1 = parseInt(data.Q2_1);
      this.Q2_2 = parseInt(data.Q2_2);
      this.Q2_3 = parseInt(data.Q2_3);
      this.Q2_4 = parseInt(data.Q2_4);

      this.Q3_1 = parseInt(data.Q3_1);
      this.Q3_2 = parseInt(data.Q3_2);
      this.Q3_3 = parseInt(data.Q3_3);
      this.Q3_4 = parseInt(data.Q3_4);

      this.additional_1 = data.ADD_1;
      this.additional_2 = data.ADD_2;
      this.additional_3 = data.ADD_3;
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    async save() {
      this.loading = true;
      const uid = localStorage.getItem("uid");
      const response = await questionnaireService
        .setQuestionnaire(
          {
            PROVINCE_ID: this.provinceId,
            DEVICE: this.device,
            NEWS: this.newsSource,
            NEWS_OTHER:
              this.newsSource === "Other" ? this.newsSource_other : "",
            INTERNET: this.internet,
            INTERNET_OTHER:
              this.internet === "Other" ? this.internet_other : "",

            Q1_1: this.Q1_1,
            Q1_2: this.Q1_2,
            Q1_3: this.Q1_3,
            Q1_4: this.Q1_4,
            Q1_5: this.Q1_5,

            Q2_1: this.Q2_1,
            Q2_2: this.Q2_2,
            Q2_3: this.Q2_3,
            Q2_4: this.Q2_4,

            Q3_1: this.Q3_1,
            Q3_2: this.Q3_2,
            Q3_3: this.Q3_3,
            Q3_4: this.Q3_4,

            ADD_1: this.additional_1,
            ADD_2: this.additional_2,
            ADD_3: this.additional_3,
          },
          uid
        )
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.save_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.loading = false;
    },
  },
  computed: {
    // store
    provinces: function () {
      return this.$store.state.ref.provinces;
    },
    hasEnoughStar() {
      return (
        parseInt(this.Q1_1) +
          parseInt(this.Q1_2) +
          parseInt(this.Q1_3) +
          parseInt(this.Q1_4) +
          parseInt(this.Q1_5) +
          parseInt(this.Q2_1) +
          parseInt(this.Q2_2) +
          parseInt(this.Q2_3) +
          parseInt(this.Q2_4) +
          parseInt(this.Q3_1) +
          parseInt(this.Q3_2) +
          parseInt(this.Q3_3) +
          parseInt(this.Q3_4) >=
        39
      );
    },
  },
  created() {
    this.fetch_data();
  },
  mounted: function () {
    this.$store.dispatch("ref/getProvinces");
  },
};
</script>

<style scoped>
.body-container {
  background-color: #0005;
}
</style>
